var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "label-choose"
  }, [_c("span", {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.$t("标签选择")) + "：")]), _c("div", {
    staticClass: "scroll"
  }, _vm._l(_vm.tagsData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "label-group"
    }, [_c("a-checkbox", {
      attrs: {
        indeterminate: item.indeterminate,
        checked: item.checkAll
      },
      on: {
        change: e => _vm.onCheckAllChange(e, index)
      }
    }, [_vm._v(_vm._s(item.fieldKey))]), _c("tag-group", {
      attrs: {
        tagsData: item.children
      },
      on: {
        changeData: data => _vm.onChangeTags(data, index)
      }
    })], 1);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };